/**
 * @author      calvin@zumper.com (Calvin Yau)
 * @copyright   Copyright (c) 2019, Zumper
 * @description modals actions
 */

import type { MODAL_TYPE } from '@zcode/state-type'
import { createAction } from 'redux-actions'
import { CLOSE_MODAL, OPEN_MODAL } from '../constants'

export const openModal = createAction<MODAL_TYPE, typeof OPEN_MODAL>(OPEN_MODAL)
export const closeModal = createAction(CLOSE_MODAL)
